import React, {useState} from 'react';
import AgentList from "./AgentList";

function LeaveMessageChat({title, teams, socket,botInfo, prefLang}) {
    const [contactAgent, setContactAgent] = useState(false)
    return(
        <div className="li-item-wrapper">
            <div className="leave-message" onClick={()=>setContactAgent(true)}>
                <i className="bot icon-headset-1"></i>{title}
            </div>
            <span className="helper-text">{botInfo?.data?.mobileAppConfig?.getInstantHelp ? botInfo?.data?.mobileAppConfig?.getInstantHelp?.[prefLang] : "Get instant help on your qurey"}</span>
            <AgentList contactAgent={contactAgent} setContactAgent={setContactAgent} teams={teams} socket={socket} botInfo={botInfo} prefLang={prefLang}/>
        </div>
    )
}
export default LeaveMessageChat;
